// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__gtPLA","container":"Footer_container__hB7OC","footerText":"Footer_footerText__top9J","footerButtons":"Footer_footerButtons__dw+Y6"};